<template>
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    {{ trans("Dashboard") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>

          <div class="d-flex align-items-center py-1">
            <router-link :to="{ name: 'avenant-type-form' }" class="btn btn-sm btn-primary">
              <i class="fad fa-plus"></i>
              {{ trans("Creer un type d'avenant") }}
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="card">
        <div class="card-body">
          <h1 class="card-title">Type d'avenant</h1>

          <table class="table table-striped gy-3 gs-3">
            <thead>
            <tr class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
              <th>{{ trans("Type") }}</th>
              <th>{{ trans("Branches") }}</th>
              <th>{{ trans('Assureurs') }}</th>
              <th>{{ trans('Ajouter') }}</th>
              <th>{{ trans('Modifier') }}</th>
              <th>{{ trans('Retirer') }}</th>
              <th>{{trans('Status')}}</th>
              <th>{{ trans("Actions") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(type, index) in avenantTypes" :key="index">
              <td>
                <div class="d-flex gap-5 fs-2">
                  <div>
                    <i :class="type.icon +' fs-2'"></i>
                  </div>
                {{ type.label }}
                </div>
              </td>
              <td>
                <div class="d-flex">
                  <div class="badge badge-light-primary m-1">
                    {{ type.branches.length }}
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex flex-wrap">
                  <div class="badge badge-light-success m-1">
                    {{ type.insurers.length }}
                  </div>
                </div>
              </td>
              <td>
                <div class="badge badge-success" v-if="type.allowAdd">
                  {{ trans('Oui') }}
                </div>
                <div class="badge badge-danger" v-else>
                  {{ trans('Non') }}
                </div>
              </td>
              <td>
                <div class="badge badge-success" v-if="type.allowEdit">
                  {{ trans('Oui') }}
                </div>
                <div class="badge badge-danger" v-else>
                  {{ trans('Non') }}
                </div>
              </td>
              <td>
                <div class="badge badge-success" v-if="type.allowRemove">
                  {{ trans('Oui') }}
                </div>
                <div class="badge badge-danger" v-else>
                  {{ trans('Non') }}
                </div>
              </td>
              <td>
                <div class="badge badge-success" v-if="type.allowStateUpdate">
                  {{ trans('Oui') }}
                </div>
                <div class="badge badge-danger" v-else>
                  {{ trans('Non') }}
                </div>
              </td>
              <td>
                <div class="d-flex">
                  <router-link :to="{ name: 'avenant-type-form', params: { id: type.id }}"
                               class="btn-icon btn-primary btn btn-xs mx-2">
                    <i class="fad fa-edit"></i>
                  </router-link>
<!--                  <button @click="deleteTypeAvenant(type.id)" class="btn-icon btn-danger btn btn-xs">-->
<!--                    <i class="fad fa-trash"></i>-->
<!--                  </button>-->
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div></div>
        </div>
      </div>
    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import Popup from "@/entity/Popup";
import {api} from "@/services/Api";
import TypeAvenant from "@/entity/TypeAvenant";
import Feature from "@/entity/Feature";
import {helper} from "@/services/Helper";
import router from "@/router";
import AvenantType from "@/entity/AvenantType";

@Component({
  components: {Base},
})
export default class AvenantTypeManager extends Vue {
  avenantTypes: AvenantType[] = [];

  helper = helper;
  featureSearch = null;

  async loadTypesAvenant() {
    const res = await api.get(api.core, "avenant/type/list");
    if (res && res.data && res.data.types) {
      this.avenantTypes = [];
      res.data.types.forEach((type: any) => {
        this.avenantTypes.push(new AvenantType(type));
      });
    }
  }

  async deleteTypeAvenant(id: number) {
    const pop = new Popup(
        "Recuperation des types d'avenant",
        "CHARGEMENT",
        "warning",
        "fad fa-trash",
        true
    );
    // const res = await api.delete(api.core, "type/avenant/delete/" + id);

    // if (res.status == 200) {
    //   this.loadTypesAvenant();
    // }
    pop.hide();
  }

  mounted() {
    this.loadTypesAvenant();
  }
}
</script>
<style scoped></style>
